import { render } from "./BaseTypeEditShell.vue?vue&type=template&id=439dcfb1"
import script from "./BaseTypeEditShell.vue?vue&type=script&lang=js"
export * from "./BaseTypeEditShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__